import { fetchSuggestionById as fetchSuggestionByIdAction } from '../../../../actions/suggestions/suggestions'
import { formatSuggestionForDisplay } from '../format-suggestion'

/**
 * ID ile öneri getirir
 * @param {Number|String} id - Öneri ID'si
 * @param {Object} params - Ek parametreler (assetId vb.)
 * @returns {Promise<Object>} Öneri verisi
 */
export const fetchSuggestionById = async (id, params = {}) => {
  try {
    // API çağrısını assetId ile yap
    const response = await fetchSuggestionByIdAction(id, params)

    // Cevabı formatla ve döndür
    if (response.code === 200 && response.data) {
      return {
        success: true,
        data: formatSuggestionForDisplay(response.data),
      }
    }

    return {
      success: false,
      message: response.message || 'Öneri bulunamadı',
      data: null,
    }
  } catch (error) {
    console.error(`Error fetching suggestion with id ${id}:`, error)
    return {
      success: false,
      message: error.message || 'Öneri yüklenirken bir hata oluştu',
      data: null,
    }
  }
}